export const MARKETING_POPUP_CLOSE_DELAY_MS = 1500;

interface ShouldRenderMarketingPopupCloseButtonArgs {
  showCloseButton: boolean;
  closeButtonReady: boolean;
}

export const shouldRenderMarketingPopupCloseButton = ({
  showCloseButton,
  closeButtonReady,
}: ShouldRenderMarketingPopupCloseButtonArgs): boolean =>
  showCloseButton && closeButtonReady;
